import { render, staticRenderFns } from "./HeadTwo.vue?vue&type=template&id=94515f3a&scoped=true&"
import script from "./HeadTwo.vue?vue&type=script&lang=js&"
export * from "./HeadTwo.vue?vue&type=script&lang=js&"
import style0 from "./HeadTwo.vue?vue&type=style&index=0&id=94515f3a&prod&lang=css&"
import style1 from "./HeadTwo.vue?vue&type=style&index=1&id=94515f3a&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "94515f3a",
  null
  
)

export default component.exports